<template>
	<div class="vip-tips flex-columnCenter" :class="more?'vip-tips1':''">
		<div class="flex-endCenter">
			<div class="">开通VIP会员，解锁
				<span class="color-orange font22"> {{number}} </span>
				个 {{title}}
			</div>
			<div class="vip-desc" v-if="more">
				<div class="desc-btn desc-btn1 flex-center">
					<span class="font22 color-orange margin-right5"> {{rush}} </span>可冲击
				</div>
				<div class="desc-btn desc-btn2 flex-center">
					<span class="font22 color-green margin-right5"> {{stable}}</span>较稳妥
				</div>
				<div class="desc-btn desc-btn3 flex-center">
					<span class="font22 color-blue margin-right5"> {{safe}} </span>可保底
				</div>
			</div>
		</div>
		<el-button class="vip-btn" @click="open">{{btn}}</el-button>
	</div>
</template>

<script>
	export default {
		name: 'VipTips',
		props: {
			number: {
				type: String,
			},
			title: {
				type: String,
				default: ''
			},
			more: {
				type: Boolean,
				default: false
			},
			btn: {
				type: String,
				default: ''
			},
			rush: {
				type: String,
				default: '0'
			},
			safe: {
				type: String,
				default: '0'
			},
			stable: {
				type: String,
				default: '0'
			},

		},
		data() {
			return {

			}
		},


		methods: {
			open() {
				this.$emit('open')
			}
		},
	}
</script>

<style lang="scss" scoped>
	// VIP提示样式
	.vip-tips {
		width: 100%;
		height: 210px;
		// position: absolute;
		bottom: 0;
		left: 0;
		// background: linear-gradient(to bottom, #FFFAF6 0%, #FFFAF6CC 20%, #FFF0E6 100%);
		background-image: url('@/assets/images/bgvip1.png');
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-size: cover;
		// cursor: pointer;
		font-size: 18px;

		.vip-tips1 {
			background-image: url('@/assets/images/bgvip.png');
		}

		.vip-desc {
			display: grid;
			grid-template-columns: repeat(3, 1fr);
			gap: 15px;
			margin-left: 25px;

			.desc-btn {
				padding: 6px 15px;
				color: #909399;
				border-radius: 4px;
			}

			.desc-btn1 {
				border: 1px solid #FF6910;
				background-color: #FFF2EA;

				span {
					color: #FF6910;
				}
			}

			.desc-btn2 {
				border: 1px solid #28b05e;
				background-color: #EFF4FF;

				span {
					color: #28b05e;
				}
			}

			.desc-btn3 {
				border: 1px solid #13C0A4;
				background-color: #EDF8F6;

				span {
					color: #13C0A4;
				}
			}
		}

		.vip-btn {
			margin-top: 28px;
			background-color: #FF6910;
			color: #ffffff;
			height: 46px;
			width: 327px;
			border: none;
			border-radius: 60px;
			font-size: 16px;
			cursor: pointer;
			transition: all 0.2s ease;
		}
	}
</style>
